import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid, regular, brands, icon } from "@fortawesome/fontawesome-svg-core/import.macro";
import PlaceEditModal from "./PlaceEditModal";
import DirectionsDialog from "./DirectionsDialog";
import "./Modal.css";
import "./PlaceModal.css";
import HTMLReader from "./HTMLReader";
import { useDispatch } from "react-redux";
import { slice1Actions } from "../../store/reducer";
import PlaceMenu from "../../CommonWeb/PlaceMenu";
import { urlSchemeToFunctions } from "../../CommonWeb/Common";
import { useSelector } from "react-redux";
import { propTypes } from "react-bootstrap/esm/Image";
import Common, { isSearchResult } from "../../Common/Common";
import AlertModal from "./AlertModal";
import Place, { Place_Source } from "../../Models/Place";
import EventEdit from "./EventEdit";
import MyToolTip from "./MyToolTip";
import GooglePlaces from "../../Models/GooglePlaces";
import AiDialog from "./AiDialog";
import Offcanvas from "react-bootstrap/Offcanvas";
import DirectionsDialogComponent from "../modals/DirectionsDialogComponent";
import MultiSelectModal from "./MultiSelectModal";

const PlaceModal = (props) => {
  const [PlaceEditModalShow, setPlaceEditModalShow] = useState(false);
  const [DirectionsDialogShow, setDirectionsDialogShow] = useState(false);
  const [HTMLReaderModal, setHTMLReaderModal] = useState(false);
  const [HTMLContent, setHTMLContent] = useState("");
  const [HTMLReaderCompact, setHTMLReaderCompact] = useState(false);
  const [HTMLReaderTitle, setHTMLReaderTitle] = useState("");
  // Only set for the Place Details flow (handleShowPlaceAttributes) — video/
  // audio/section content leave this null, which keeps Next/Previous paging
  // hidden for those (see showPaging below).
  const [HTMLReaderPlaceId, setHTMLReaderPlaceId] = useState(null);
  const [SelectedPlace, setSelectedPlace] = useState(null);
  const [ShowEventEdit, setShowEventEdit] = useState(false);
  const [EventEditMode, setShowEventMode] = useState("MODIFY");
  const [EventEditWhere, setShowEventWhere] = useState("after");

  const [AlertModalShow, setAlertModalShow] = useState(false);
  const [AlertModalTitle, setAlertModalTitle] = useState("");
  const [AlertModalMessage, setAlertModalMessage] = useState("");
  const [AlertModalButtons, setAlertModalButtons] = useState([]);
  const [AiDialogShow, setAiDialogShow] = useState(null);
  const [ShowOffcanvas, setShowOffcanvas] = useState(false);
  const [MultiselectItems, setMultiselectItems] = useState([]);
  const [MultiselectSelectedItems, setMultiselectSelectedItems] = useState([]);
  const [MultiselectMode, setMultiselectMode] = useState("uni");
  //const [MultiselectCallback, setMultiselectCallback] = useState(null);
  const [MultiselectTitle, setMultiselectTitle] = useState("Select");
  const [MultiselectSearchText, setMultiselectSearchText] = useState("");
  const [ShowMultiselect, setShowMultiselect] = useState(null);
  const [AutoSetPhotoLoading, setAutoSetPhotoLoading] = useState(false);

  const dispatch = useDispatch();
  const waypointsArray = useSelector((state) => state.waypointsArray);
  const from_loc = useSelector((state) => state.fromLoc);
  let user_info = useSelector((state) => state.user_info);
  let SearchResultsPlacesList = useSelector((state) => state.SearchResultsPlacesList);
  let MobileMode = useSelector((state) => state.MobileMode);
  let CurrentAppScreen = useSelector((state) => state.CurrentAppScreen);
  let GuideEditMode = useSelector((state) => state.GuideEditMode);
  let ScheduleName = useSelector((state) => state.ScheduleName);
  let AppSettings = useSelector((state) => state.AppSettings);
  let showHiddenPlace = useSelector((state) => state.showHiddenPlace);
  const advancedMode = user_info?.advanced_mode === "On";

  // useEffect(() => {
  //   if (window.guide_obj != null && typeof window.guide_obj !== "undefined") {
  //     const place = window.guide_obj.places.getPlace(props.i);
  //     setSelectedPlace(place);
  //   }
  // }, [props.i]);

  function handleCenterInMap() {
    const place = window.guide_obj.places.getPlace(props.i);
    if (place == null) return;
    dispatch(slice1Actions.setMapCenterPlace({ place: place }));
    if (MobileMode) {
      // Record where we're jumping from so the back arrow PlacesHeader.js
      // shows on Map (when AppScreenStack is non-empty) can return here —
      // CurrentAppScreen itself has no history, it's just overwritten.
      // Found/fixed 2026-09-09.
      dispatch(slice1Actions.pushAppScreen({ value: CurrentAppScreen }));
      dispatch(slice1Actions.setCurrentAppScreen({ value: "Map" }));
    } else {
      dispatch(slice1Actions.centerMapToPlaces({ value: [place] }));
      window.location.href = "#map-start";
    }
    props.onHide();
  }

  function handleShowStreetView() {
    // const place = window.guide_obj.places.getPlace(props.i);
    // if (place == null) return;
    // const StreetViewLocation = { lat: place.Lat, lng: place.Longi };

    // dispatch(slice1Actions.setStreetViewLocation({ value: StreetViewLocation }));

    PlaceMenu.handleShowStreetView(props.i);
    props.onHide();
  }

  function handleWeatherForecast() {
    PlaceMenu.handleWeatherForecast(props.i);
    props.onHide();
  }

  function handleShowInGoogleMaps() {
    PlaceMenu.handleShowInGoogleMaps(props.i);
    props.onHide();
  }

  function handleShowSearchResultInGoogleMaps() {
    const place = props.place;
    if (!place) return;
    if (place.Source === Place_Source.GOOGLEPLACES) {
      handleShowPlaceUrl();
      return;
    }
    window.open(`https://www.google.com/maps/search/?api=1&query=${place.Lat},${place.Longi}`, "_blank");
    props.onHide();
  }

  function handleShowPlaceAttributes() {
    let htmlString = PlaceMenu.handleShowPlaceAttributes(props.i, SearchResultsPlacesList);
    htmlString = urlSchemeToFunctions(htmlString);
    // Changed 2026-10-05, user's call: always show the local dialog
    // regardless of MobileMode — matches PlaceCard.js's identical fix; see
    // its comment for the full reasoning. No MobileMode branch needed.
    setHTMLReaderTitle("Place Details");
    setHTMLContent(htmlString);
    setHTMLReaderCompact(false);
    setHTMLReaderPlaceId(props.i);
    setHTMLReaderModal(true);
  }

  const closeHTMLReader = () => {
    setHTMLReaderModal(false);
    window.getTime = function () {};
    props.onHide();
  };

  // Next/Previous through `props.placesList` (an ordered array of place IDs
  // matching the currently-displayed Places order) — mirrors the native
  // mobile app's HTMLViewer paging. Only wired up for the Place Details flow
  // (HTMLReaderPlaceId is set there and nowhere else).
  const goToPlace = (offset) => {
    const list = props.placesList;
    if (list == null || list.length <= 1 || HTMLReaderPlaceId == null) return;
    const index = list.indexOf(HTMLReaderPlaceId);
    if (index === -1) return;
    const nextIndex = index + offset;
    if (nextIndex < 0 || nextIndex >= list.length) return;
    const nextId = list[nextIndex];
    let htmlString = PlaceMenu.handleShowPlaceAttributes(nextId, SearchResultsPlacesList);
    htmlString = urlSchemeToFunctions(htmlString);
    setHTMLContent(htmlString);
    setHTMLReaderPlaceId(nextId);
  };

  const handleShowPlaceUrl = () => {
    props.onHide();
    let place = window.guide_obj.places.getPlace(props.i);
    if (place === null) {
      const index = SearchResultsPlacesList.findIndex((x) => x.ID === props.i);
      if (index !== -1) place = SearchResultsPlacesList[index];
    }
    if (place == null) return "";
    let link = place.getFirstHLink();
    if (link.includes("place_id=")) {
      const parts = link.split("=");
      //console.log("parts", parts);
      GooglePlaces.getMoreDetails(getMoreDetailsCallback, parts[1]);
      props.onHide();
      return;
    }
    if (link !== "") {
      let win = window.open(link, "_blank");
      if (win) win.focus();
      props.onHide();
      return null;
    }
  };

  const copyPhotoToPlace = () => {
    setMultiselectItems(window.guide_obj.places.getPlacesToDisplay(null));
    setMultiselectSelectedItems([]);
    setMultiselectMode("uni");
    setMultiselectTitle(`Select place`);
    setShowMultiselect(true);
  };

  const autoSetPhoto = () => {
    if (AutoSetPhotoLoading) return;
    setAutoSetPhotoLoading(true);
    // licenseSafe: only images with no usage conditions (see PlaceMenu._autoSetPhotoLicenseSafe).
    PlaceMenu.autoSetPhoto(props.place, () => {
      setAutoSetPhotoLoading(false);
      update_display();
    }, { licenseSafe: true });
  };

  const clearPhoto = () => {
    PlaceMenu.clearPhoto(props.place);
    update_display();
  };

  const selectPlacesCallBack = (Places) => {
    if (Places.length < 1) return;
    const index = SearchResultsPlacesList.findIndex((x) => x.ID === props.i);
    if (index === -1) return;
    let new_place = SearchResultsPlacesList[index];
    let old_place = window.guide_obj.places.getPlace(Places[0].value);
    if (old_place === null) return;
    old_place.Photo_m = new_place.Photo_m;
    old_place.Photo = new_place.Photo;
    window.guide_obj.places.modifyPlace(old_place, old_place.ID);
    props.onHide();
    dispatch(slice1Actions.setGuide({ guide: null }));
  };

  const handleShowPathLink = () => {
    //props.onHide();
    setTimeout(_handleShowPathLink, 300);
  };

  const _handleShowPathLink = () => {
    let place = window.guide_obj.places.getPlace(props.i);
    if (place == null) return "";
    if (place.Link.type === "none") return;
    if (place.Link.type === "video") testVideo(place, 0);
    else if (place.Link.type === "audio") testAudio(place.Link.value);
    else if (place.Link.type === "section") testSection(place.Link.value);
    else if (place.Link.type === "url") testURL(place.Link.value);
    else if (place.Link.type === "path") {
      let pathlink_place = window.guide_obj.places.getPlace(place.Link.value);
      if (pathlink_place === null) return;
      //console.log("pathlink_place", pathlink_place);
      const closest = pathlink_place.findClosestPointInPath(place.Lat, place.Longi);
      //console.log("closest", closest);
      if (closest !== null) {
        testVideo(pathlink_place, closest.elapsed_time);
      }
    }
  };
  const testVideo = (pathlink_place, elapsed_time) => {
    // setYouTubeDialogShow(true);
    // return;
    // if(typeof pathlink_place.Link === "undefined") return;
    if (pathlink_place.Link.type !== "video") return;
    let video_url = pathlink_place.Link.value;
    if (typeof video_url === "undefined") return;
    if (video_url === "") return;

    let video_start = 0;
    let videoLinkOffset = 0;
    try {
      videoLinkOffset = pathlink_place.Link.offset;
      video_start = parseInt(videoLinkOffset);
    } catch (e) {}
    //console.log("=========================testVideo", video_start);
    video_start += elapsed_time;
    //console.log("testVideo", video_start, elapsed_time);

    if (!(video_url.includes("https://www.youtu") || video_url.includes("https://youtu"))) {
      // The YouTube-iframe-API player below (with its playback-position/path-
      // sync tracking) only applies to real YouTube links. A place's video
      // link can also be a gdrive link or a direct video file, which have no
      // such API — fall back to a plain embed for those, same as the
      // videolink: scheme handling elsewhere. Without this branch, a non-
      // YouTube URL was fed to the YouTube player as if it were a video ID,
      // producing an empty/blank player.
      let fallback_html = "";
      if (video_url.startsWith("gdrive:")) {
        const fileId = video_url.slice(7);
        fallback_html = `<iframe style="max-width: 100%; width: 448px; height: 336px;"
                        src="https://drive.google.com/file/d/${fileId}/preview"
                        frameborder="0" allowfullscreen="allowfullscreen">
                      </iframe>`;
      } else if (video_url.includes("https://drive.google.com")) {
        const video_parts = video_url.split("/");
        const direct_url = `https://docs.google.com/uc?export=download&id=${video_parts[5]}`;
        fallback_html = `<video width="448" height="336" controls autoplay muted>
                      <source src="${direct_url}" type="video/mp4">
                        Video format not supported use mp4, WebM or Ogg.
                      </video>`;
      } else {
        let videoType = "video/mp4";
        if (video_url.toUpperCase().endsWith("WEBM")) videoType = "video/webm";
        else if (video_url.toUpperCase().endsWith("OGG")) videoType = "video/ogg";
        fallback_html = `<video width="448" height="336" controls autoplay muted>
                      <source src="${video_url}" type="${videoType}">
                        Video format not supported use mp4, WebM or Ogg.
                      </video>`;
      }
      // Same reset as the YouTube branch below, same reasoning (onHide's
      // placemenulink check depends on the title being reliable). Also
      // resets HTMLReaderPlaceId — otherwise a stale ID from a previous
      // Place Details view would wrongly show paging controls here too
      // (showPaging only checks PlaceId != null, not the title). Found
      // 2026-10-06.
      setHTMLReaderTitle("Video");
      setHTMLReaderPlaceId(null);
      setHTMLContent(`<div style="display:flex;justify-content:center;">${fallback_html}</div>`);
      setHTMLReaderCompact(true);
      setHTMLReaderModal(true);
      return;
    }

    let video_url_parts = video_url.split("/");
    let yvideo = video_url_parts[video_url_parts.length - 1];
    yvideo = yvideo.replace("watch?v=", "");

    // let video_html = `<iframe id=MyYoutubeIframe" style="max-width: 100%; width: 640px; height: 480px;"
    //                       src="https://www.youtube.com/embed/${yvideo}?start=${video_start}&autoplay=1&mute=1" frameborder="0" allowfullscreen="allowfullscreen">
    //                   </iframe>`;

    // let video_html = `<div>This wil be rendered</div>
    //                   <script>
    //                     alert('testing')
    //                   </script>`;
    let random = Math.random().toString(36).slice(2);
    // The YouTube JS API (YT.Player) doesn't actually play video inside this
    // content viewer's srcDoc iframe — YouTube sees a null/opaque origin with
    // no referrer and refuses playback (confirmed by reproducing the exact
    // script standalone: state gets stuck at -1/unstarted in a srcDoc iframe,
    // but reaches "playing" normally from a real http(s) origin). Use a plain
    // embed iframe for reliable playback instead, and approximate elapsed
    // video time from wall-clock time since play started (rather than a real
    // player position) to keep driving the map-sync feature. This assumes
    // the video isn't paused/seeked by the viewer. Fixed 2026-09-12.
    let video_html = `<style>.container {
      position: relative;
      width: 100%;
      max-width: 448px;
      margin: 0 auto;
      height: 0;
      padding-bottom: 56.25%;
  }
  .video {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
  }
    </style>
    <div class="container">
      <iframe id="player${random}" class="video"
        src="https://www.youtube.com/embed/${yvideo}?start=${video_start}&autoplay=1&mute=1"
        frameborder="0" allowfullscreen="allowfullscreen">
      </iframe>
    </div>
    <script>
      var videoStart${random} = ${video_start};
      var playStartedAt${random} = Date.now();
      function getTime${random}() {
        var elapsed = videoStart${random} + (Date.now() - playStartedAt${random}) / 1000;
        window.parent.TimeFromYoutube(elapsed, ${JSON.stringify(pathlink_place.ID)}, 1, ${videoLinkOffset});
        setTimeout(getTime${random}, 1000);
      }
      setTimeout(getTime${random}, 1000);
    </script>`;

    // Reset explicitly — otherwise a prior Place Details view left this
    // "Place Details", and onPlaceMenuLink's check below would wrongly
    // treat a video as Place Details too. Also resets HTMLReaderPlaceId, for
    // the same reason paging shouldn't appear here either. Found 2026-10-06.
    setHTMLReaderTitle("Video");
    setHTMLReaderPlaceId(null);
    setHTMLContent(video_html);
    setHTMLReaderCompact(true);
    setHTMLReaderModal(true);
  };

  const testAudio = (audio_url) => {
    let audioType = "audio/mpeg";
    if (audio_url.toUpperCase().endsWith("WAV")) audioType = "audio/wav";
    else if (audio_url.toUpperCase().endsWith("OGG")) audioType = "audio/ogg";
    else if (audio_url.toUpperCase().endsWith("MP3")) audioType = "audio/mpeg";
    else audioType = "audio/mp4";
    const audio_html = `<audio style="max-width: 100%; width: 600px;" controls="controls" controlsList="nodownload" autoplay>
          <source src="${audio_url}" type="${audioType}">
        Audio format not supported use mp3, wav, m4a or ogg.
        </audio>`;
    // dispatch(slice1Actions.setHTMLTitle({ value: "Audio" }));
    // dispatch(slice1Actions.setHTMLToSHow({ value: audio_html }));
    // dispatch(slice1Actions.setShowHTMLReader({ value: true }));
    // window.location.href = "#home-start";
    // let homeDiv = document.getElementById("home-content-start");
    // homeDiv.scrollIntoView();
    // Same reset as testVideo above, same reasoning.
    setHTMLReaderTitle("Audio");
    setHTMLReaderPlaceId(null);
    setHTMLContent(audio_html);
    setHTMLReaderCompact(false);
    setHTMLReaderModal(true);
  };

  const testSection = (section_id) => {
    let section = window.guide_obj.findSection(section_id);
    if (section == null) {
      //Alert.alert("section not found");
      return;
    }
    let htmlString = urlSchemeToFunctions(section.html);
    dispatch(slice1Actions.setHTMLTitle({ value: section.Title }));
    dispatch(slice1Actions.setHTMLToSHow({ value: htmlString }));
    dispatch(slice1Actions.setShowHTMLReader({ value: true }));
    window.location.href = "#home-start";
    let homeDiv = document.getElementById("home-content-start");
    homeDiv.scrollIntoView();
    props.onHide();

    // setHTMLContent(htmlString);
    // setHTMLReaderModal(true);
  };

  const testURL = (url) => {
    let win = window.open(url, "_blank");
    if (win) win.focus();
  };

  const getMoreDetailsCallback = (place_id, details) => {
    if (details === null) return;
    let hlink = "";
    //console.log("getMoreDetailsCallback", details);
    if (typeof details.url != "undefined") {
      if (details.url.includes(";")) {
        const urls = details.url.split(";");
        hlink = `${urls[0]}`;
      } else hlink = `${details.url}`;
    }
    //console.log("getMoreDetailsCallback", hlink);
    if (hlink !== "") {
      let win = window.open(hlink, "_blank");
      if (win) win.focus();
      return null;
    }
  };

  // function handleShowPlaceUrl() {
  //   //console.log("handleShowPlaceURL");
  //   let htmlString = PlaceMenu.handleShowPlaceUrl(props.i);
  //   // if (htmlString == null) return;
  //   // htmlString = urlSchemeToFunctions(htmlString);
  //   // dispatch(slice1Actions.setHTMLTitle({ value: "Place Info" }));
  //   // dispatch(slice1Actions.setHTMLToSHow({ value: htmlString }));
  //   // dispatch(slice1Actions.setShowHTMLReader({ value: true }));
  //   // window.location.href = "#home-start";
  //   // var homeDiv = document.getElementById("home-content-start");
  //   // if (MobileMode) dispatch(slice1Actions.setCurrentAppScreen({ value: "Home" }));
  //   // else homeDiv.scrollIntoView();
  //   props.onHide();
  // }

  function handleShowPlaceInfo() {
    const place = window.guide_obj.places.getPlace(props.i);
    if (place == null) return;
    let htmlString = place.Info;
    if (htmlString == null) return;
    htmlString = urlSchemeToFunctions(htmlString);
    dispatch(slice1Actions.setHTMLTitle({ value: "Place Notes" }));
    dispatch(slice1Actions.setHTMLToSHow({ value: htmlString }));
    dispatch(slice1Actions.setShowHTMLReader({ value: true }));
    window.location.href = "#home-start";
    var homeDiv = document.getElementById("home-content-start");
    if (MobileMode) dispatch(slice1Actions.setCurrentAppScreen({ value: "Home" }));
    else homeDiv.scrollIntoView();
    props.onHide();
  }

  function handleGoToYelp() {
    PlaceMenu.handleGoToYelp(props.i);
    props.onHide();
  }

  function handleGoToFoursquare() {
    PlaceMenu.handleGoToFoursquare(props.i);
    props.onHide();
  }

  function handleSetAsCurrentLocation() {
    const place = window.guide_obj.places.getPlace(props.i);
    if (place == null) return;
    const CurrentLocation = { latitude: place.Lat, longitude: place.Longi };

    dispatch(slice1Actions.setCurrentLocation({ value: CurrentLocation }));
    dispatch(slice1Actions.setGuide({ guide: null }));
    props.onHide();
  }

  function handleEditPlace() {
    setPlaceEditModalShow(true);
    //props.onHide();
  }

  function handleDeletePlace() {
    const place = window.guide_obj.places.getPlace(props.i);
    if (place === null) {
      props.onHide();
      return;
    }
    myConfirm("This will delete the place. Continue?", [
      { Title: "OK", Method: () => _handleDeletePlace(place) },
      { Title: "CANCEL", Method: null },
    ]);
  }

  function _handleDeletePlace(place) {
    window.guide_obj.places.deletePlace(place);
    if (showHiddenPlace.length > 0) {
      let hidden_places = [];
      for (let i = 0; i < showHiddenPlace.length; i++) {
        if (showHiddenPlace[i].ID !== place.ID) {
          hidden_places.push(showHiddenPlace[i]);
          break;
        }
      }
      dispatch(slice1Actions.setShowHiddenPlace({ value: hidden_places }));
    }
    //const index = _ShowHiddenPlace.findIndex((x) => x.ID === place.ID);
    dispatch(slice1Actions.setGuide({ guide: null }));
    props.onHide();
  }

  const handleModifyLocation = () => {
    //const place = window.guide_obj.places.getPlace(props.i);
    //if (place == null) return;
    props.action("edit shape");
    props.onHide();
  };

  function showDirectionsPlace() {
    const _place = window.guide_obj.places.getPlace(props.i);
    if (_place == null) return;
    showDirections({ Lat: _place.Lat, Longi: _place.Longi }, null, null);
  }

  function showDirectionsPOI(_poi) {
    showDirections({ Lat: _poi.coordinate.latitude, Longi: _poi.coordinate.longitude });
  }

  function showDirectionsMap(_mapCoordinate) {
    showDirections({ Lat: _mapCoordinate.latitude, Longi: _mapCoordinate.longitude });
  }

  function showDirections(to_loc) {
    let waypoints = "";
    if (waypointsArray.length !== 0) {
      waypoints = "&waypoints=";
      for (let i = waypointsArray.length - 1; i >= 0; i--) {
        waypoints += waypoints === "&waypoints=" ? "" : "|";
        waypoints += `${waypointsArray[i].Lat},${waypointsArray[i].Longi}`;
      }
    }
    let _url = `https://www.google.com/maps/dir/?api=1&destination=${to_loc.Lat},${to_loc.Longi}${waypoints}`;
    if (from_loc !== null)
      _url = `https://www.google.com/maps/dir/?api=1&origin=${from_loc.Lat},${from_loc.Longi}&destination=${to_loc.Lat},${to_loc.Longi}${waypoints}`;
    //console.log(action);

    let win = window.open(_url, "_blank");
    if (win) win.focus();

    dispatch(slice1Actions.setFromLoc({ value: null }));
    dispatch(slice1Actions.setWaypointsArray({ value: [] }));
    props.onHide();
  }

  function fromDirectionsPlace() {
    const _place = window.guide_obj.places.getPlace(props.i);
    if (_place == null) return;
    let from_loc = { Name: _place.Name, Lat: _place.Lat, Longi: _place.Longi };
    //dispatch(slice1Actions.setFromLoc({ value: from_loc }));
    //dispatch(slice1Actions.setWaypointsArray({ value: [] }));

    dispatch(
      slice1Actions.setDirectionsFromLocation({
        value: from_loc,
      })
    );
    window.DirectionsFromLocation = from_loc;

    props.onHide();
  }

  function toDirectionsPlace() {
    const _place = window.guide_obj.places.getPlace(props.i);
    if (_place == null) return;
    let to_loc = { Name: _place.Name, Lat: _place.Lat, Longi: _place.Longi };
    dispatch(slice1Actions.setToLoc({ value: to_loc }));
    //dispatch(slice1Actions.setWaypointsArray({ value: [] }));
    dispatch(
      slice1Actions.setDirectionsToLocation({
        value: to_loc,
      })
    );
    window.DirectionsToLocation = to_loc;
    showDirectionsDialog();
    //props.onHide();
  }

  function fromDirectionsPOI(_poi) {
    let from_loc = { Lat: _poi.coordinate.latitude, Longi: _poi.coordinate.longitude };
    dispatch(slice1Actions.setFromLoc({ value: from_loc }));
    dispatch(slice1Actions.setWaypointsArray({ value: [] }));
    props.onHide();
  }

  function fromDirectionsMap(_mapCoordinate) {
    let from_loc = { Lat: _mapCoordinate.latitude, Longi: _mapCoordinate.longitude };
    dispatch(slice1Actions.setFromLoc({ value: from_loc }));
    dispatch(slice1Actions.setWaypointsArray({ value: [] }));
    props.onHide();
  }

  function addWayPointPlace() {
    // const _place = window.guide_obj.places.getPlace(props.i);
    // if (_place == null) return;
    // let _waypointsArray = JSON.parse(JSON.stringify(waypointsArray));
    // _waypointsArray.push({ Lat: _place.Lat, Longi: _place.Longi });
    // dispatch(slice1Actions.setWaypointsArray({ value: _waypointsArray }));
    // props.onHide();

    const _place = window.guide_obj.places.getPlace(props.i);
    if (_place == null) return;
    //let DirectionsWaypointPlaces = JSON.parse(JSON.stringify(window.DirectionsWaypointPlaces));
    let DirectionsWaypointsLocation = JSON.parse(JSON.stringify(window.DirectionsWaypointsLocation));
    //DirectionsWaypointPlaces.push(_place);
    DirectionsWaypointsLocation.push({ Name: _place.Name, Lat: _place.Lat, Longi: _place.Longi });
    //window.DirectionsWaypointPlaces = DirectionsWaypointPlaces;
    window.DirectionsWaypointsLocation = DirectionsWaypointsLocation;
    dispatch(slice1Actions.setDirectionsWaypointsLocation({ value: DirectionsWaypointsLocation }));
    props.onHide();
  }

  function addWayPointPOI() {
    const _place = window.guide_obj.places.getPlace(props.i);
    if (_place == null) return;
    let _waypointsArray = JSON.parse(JSON.stringify(waypointsArray));
    _waypointsArray.push({ Lat: _place.Lat, Longi: _place.Longi });
    dispatch(slice1Actions.setWaypointsArray({ value: _waypointsArray }));
    props.onHide();
  }

  function addWayPointMap() {
    const _place = window.guide_obj.places.getPlace(props.i);
    if (_place == null) return;
    let _waypointsArray = JSON.parse(JSON.stringify(waypointsArray));
    _waypointsArray.push({ Lat: _place.Lat, Longi: _place.Longi });
    dispatch(slice1Actions.setWaypointsArray({ value: _waypointsArray }));
    props.onHide();
  }
  const getSearchPlace = () => {
    const place = SearchResultsPlacesList.find((x) => x.ID === props.i);
    return place;
  };

  const addResultToguide = () => {
    dispatch(slice1Actions.addResultToGuide({ value: props.i }));
    dispatch(slice1Actions.setGuide({ guide: null }));
    props.onHide();
  };

  const removeFromSearchResults = () => {
    dispatch(slice1Actions.removeFromSearchResults({ value: props.i }));
    dispatch(slice1Actions.setGuide({ guide: null }));
    props.onHide();
  };

  const update_display = () => {
    dispatch(slice1Actions.setGuide({ guide: null }));
  };

  const PlaceEditCallback = () => {
    dispatch(slice1Actions.resetHomeScreen({ value: null }));
    dispatch(slice1Actions.setGuide({ guide: null }));
  };

  const _isSearchResult = () => {
    const index = SearchResultsPlacesList.findIndex((x) => x.ID === props.i);
    return index !== -1;
  };

  const showDirectionsDialog = () => {
    // setDirectionsDialogShow(true);
    dispatch(slice1Actions.setShowOffcanvas({ value: true }));
    props.onHide();
  };

  // const filterPlacesByArea = () => {
  //   props.filter(props.i, true);
  // };

  const filterPlacesByArea = () => {
    const _place = window.guide_obj.places.getPlace(props.i);
    if (_place == null) return;
    let coordinates = _place.getCoordinates();
    let path = [];
    coordinates.forEach((element) => {
      path.push({ lat: element.latitude, lng: element.longitude });
    });
    // let coordinates = [];
    // selectedShape.coordinates.forEach((element) => {
    //   coordinates.push({ lat: element.latitude, lng: element.longitude });
    // });
    const area = new window.google.maps.Polygon({
      paths: path,
      strokeColor: "#FF0000",
      strokeOpacity: 0.8,
      strokeWeight: 2,
      fillColor: "#FF0000",
      fillOpacity: 0.35,
      editable: true,
    });
    let containedPlaces = [];
    //const allPlaces = window.guide_obj.places.getPlacesToDisplay(null);
    const allPlaces = window.guide_obj.places.getChoosePlacesList();
    for (let i = 0; i < allPlaces.length; i++) {
      const place = allPlaces[i].value; //window.guide_obj.places.getPlace(_place.ID)
      const latLng = new window.google.maps.LatLng(place.Lat, place.Longi); //{ lat: place.Lat, lng: place.Longi };
      if (window.google.maps.geometry.poly.containsLocation(latLng, area)) {
        containedPlaces.push(place);
      }
    }
    dispatch(slice1Actions.ClearAllFilters({ value: null }));
    dispatch(slice1Actions.SetPlacesFilter({ value: containedPlaces }));
    dispatch(slice1Actions.setGuide({ guide: null }));
    props.onHide();
  };

  const myAlert = (message, title, buttons) => {
    setAlertModalMessage(message);
    setAlertModalTitle(title == null ? "Message" : title);
    setAlertModalButtons(buttons == null ? [{ Title: "OK", Method: null }] : buttons);
    setAlertModalShow(true);
  };
  const myConfirm = (message, buttons) => {
    setAlertModalTitle("Confirmation");
    setAlertModalMessage(message);
    setAlertModalButtons(buttons);
    setAlertModalShow(true);
  };
  const displayMenuInfo = (menu_item_info) => {
    myAlert(menu_item_info, "Info");
  };

  const _AnimatePath = () => {
    const _place = window.guide_obj.places.getPlace(props.i);
    if (_place == null) {
      props.onHide();
      return;
    }
    props.onHide();
    const latLongs = _place.getLatLongsForPlace();
    console.log("latLongs", latLongs);
    if (latLongs.length === 0) return;
    //const latLng = new window.google.maps.LatLng(latLongs[0].Lat, latLongs[0].Longi);
    //dispatch(slice1Actions.setStreetViewLocation({ guide: latLng }));
    //const _MapCenter = latLongs[0];
    //dispatch(slice1Actions.centerMapToLoc({ value: _MapCenter }));
    AnimatePath1(latLongs, 0);
    //window.AnimatePath(_place);
  };

  const AnimatePath1 = (latLongs, i) => {
    if (i > latLongs.length - 1) return;
    const _MapCenter = latLongs[i];
    dispatch(slice1Actions.centerMapToLoc({ value: _MapCenter }));
    setTimeout(() => AnimatePath2(latLongs, (i += 1)), 1000);
  };

  const AnimatePath2 = (latLongs, i) => {
    if (i > latLongs.length - 1) return;
    const _MapCenter = latLongs[i];
    dispatch(slice1Actions.centerMapToLoc({ value: _MapCenter }));
    setTimeout(() => AnimatePath1(latLongs, (i += 1)), 1000);
  };

  // Reopens the Directions dialog with the exact From/Waypoints/To places
  // (and travel mode) this Path was originally built from — only possible
  // for a Path created/edited through that dialog (place.DirectionsRoute),
  // not a hand-drawn one, a KML import, or WalkAI's own generated paths.
  // window.DirectionsEditPlaceId is how DirectionsDialogComponent.js knows
  // to update THIS place on "Go" instead of drawing a new one.
  const handleEditDirections = () => {
    window.DirectionsEditPlaceId = props.place.ID;
    dispatch(slice1Actions.setShowOffcanvas({ value: true }));
    props.onHide();
  };

  const handleReverseDirection = () => {
    const _place = window.guide_obj.places.getPlace(props.i);
    if (_place == null) {
      props.onHide();
      return;
    }
    _place.reverseLineDirection();
    dispatch(slice1Actions.setGuide({ guide: null }));
    props.onHide();
    return;
    let points = _place.Points;
    if (points === null) {
      props.onHide();
      return;
    }
    let points_ar = points.split(":");
    let points_ar_rev = points_ar.reverse();
    let new_points = points_ar_rev.join(":");
    _place.Points = new_points;
    dispatch(slice1Actions.setGuide({ guide: null }));
    props.onHide();
    // let new_points = "";
    // for (let i = points_ar.length - 1; i >= 0; i--) {
    //   if (new_points !== "") new_points += ":";
    //   new_points += points_ar[i];
    // }
    //_place.Points = new_points;

    //let new_place = JSON.parse(JSON.stringify(_place));
    //let new_place = Object.assign({}, _place);

    // let new_place = new Place(window.guide_obj.places);
    // const id = _place.ID;
    // new_place.copy(_place);
    // new_place.ID = id;
    // new_place.Points = new_points;
    //window.guide_obj.places.deletePlace(_place);
    //window.guide_obj.places.addPlace(_place);
    //setTimeout(() => add_place(new_place), 1000);
  };

  // const add_place = (place) => {
  //   window.guide_obj.places.addPlace(place);
  //   dispatch(slice1Actions.setGuide({ guide: null }));
  // };

  function handleAddEventA() {
    setShowEventMode("ADD");
    setShowEventWhere("end");
    setShowEventEdit(true);
  }
  const showWebImages = () => {
    const _place = window.guide_obj.places.getPlace(props.i);
    if (_place == null) {
      props.onHide();
      return;
    }
    let _url = `https://www.google.com/search?tbm=isch&q=${_place.Name}`;
    if (_place.City !== "") _url += "+" + _place.City;
    if (_place.Country !== "") _url += "+" + _place.Country;
    let win = window.open(_url, "_blank");
    if (win) win.focus();
  };

  const showWebVideos = () => {
    const _place = window.guide_obj.places.getPlace(props.i);
    if (_place == null) {
      props.onHide();
      return;
    }
    let _url = `https://www.youtube.com/results?search_query=${_place.Name}`;
    if (_place.City !== "") _url += "+" + _place.City;
    if (_place.Country !== "") _url += "+" + _place.Country;
    let win = window.open(_url, "_blank");
    if (win) win.focus();
  };

  const showWebArticles = () => {
    const _place = window.guide_obj.places.getPlace(props.i);
    if (_place == null) {
      props.onHide();
      return;
    }
    let _url = `http://www.google.com/search?q=${_place.Name}`;
    if (_place.City !== "") _url += "+" + _place.City;
    if (_place.Country !== "") _url += "+" + _place.Country;
    let win = window.open(_url, "_blank");
    if (win) win.focus();
  };

  const EventEditCallback = () => {
    dispatch(slice1Actions.resetHomeScreen({ value: null }));
    dispatch(slice1Actions.setGuide({ guide: null }));
    props.onHide();
  };

  const combinePlaces = () => {
    const _place = window.guide_obj.places.getPlace(props.i);
    if (_place == null) {
      props.onHide();
      return;
    }
    const items = window.guide_obj.places.getPlacesToDisplay();
    dispatch(slice1Actions.setMultiselectCallback({ value: combinePlacesCallBack }));
    dispatch(slice1Actions.setMultiselectItems({ value: items }));
    dispatch(slice1Actions.setMultiselectSelectedItems({ value: [] }));
    dispatch(slice1Actions.setMultiselectMode({ value: "multi" }));
    dispatch(slice1Actions.setMultiselectSearchText({ value: "" }));
    dispatch(slice1Actions.setMultiselectTitle({ value: "Select Places" }));
    dispatch(slice1Actions.setShowMultiselect({ value: true }));
  };

  const combinePlacesCallBack = (places) => {
    const _place = window.guide_obj.places.getPlace(props.i);
    if (_place == null) {
      props.onHide();
      return;
    }
    if (places.length === 0) return;
    //console.log("combinePlacesCallBack", places);
    window.guide_obj.places.combineWithPlaces(_place, places);
    dispatch(slice1Actions.setGuide({ guide: null }));
    props.onHide();
    // updateMainScheduleAndDoc();
  };

  // const updateMainScheduleAndDoc = () => {
  //   myAlert("Update Main Schedule and Guide document with these changes?", "Update", [
  //     { Title: "OK", Method: _updateMainScheduleAndDoc },
  //     { Title: "CANCEL", Method: () => props.onHide() },
  //   ]);
  // };

  // const _updateMainScheduleAndDoc = () => {
  //   if (ScheduleName !== "Main") window.guide_obj.schedule.copySchedule(ScheduleName, "Main");
  //   const html = window.guide_obj.createHTMLItinerary(ScheduleName, GuideSettings.itinerary);
  //   //window.guide_obj.document = html;
  //   //dispatch(slice1Actions.setGuide({ guide: null }));

  //   window.guide_obj.document = html;
  //   dispatch(slice1Actions.clearHTMLStack());
  //   //dispatch(slice1Actions.popHTMLStack());
  //   dispatch(slice1Actions.setHomeScreen({ value: html }));
  //   props.onHide();
  // };

  if (ShowEventEdit)
    return (
      <EventEdit
        show={ShowEventEdit}
        onHide={() => setShowEventEdit(false)}
        event={null}
        mode={EventEditMode}
        place={window.guide_obj.places.getPlace(props.i)}
        where={EventEditWhere}
        schedule_name={ScheduleName}
        callback={() => EventEditCallback()}
      />
    );
  if (PlaceEditModalShow)
    return (
      <PlaceEditModal
        show={PlaceEditModalShow}
        onHide={() => setPlaceEditModalShow(false)}
        img={props.img}
        name={props.name}
        index={props.i}
        mainIndex={props.mainIndex}
        id={props.id}
        place={props.place}
        groups={window.guide_obj == null ? "" : window.guide_obj.groupNamesFromIDs(props.place.Group)}
        category={window.guide_obj == null ? "" : window.guide_obj.categoryNamesFromIDs(props.place.Category)}
        user_info={user_info}
        mode={"Edit"}
        update_display={PlaceEditCallback}
        onHidePrevious={props.onHide}
        folder={props.folder}
        setImageFolder={props.setImageFolder}
      />
    );
  const placeType = props.place.PType === "Icon" ? "Location" : props.place.PType === "PolyLine" ? "Path" : "Area";
  const isIcon     = props.place.PType === "Icon";
  const isPolyLine = props.place.PType === "PolyLine";
  const isPolygon  = props.place.PType === "Polygon";

  const headerIconClass = isPolyLine ? "path" : isPolygon ? "area" : "";
  const headerIcon      = isPolyLine
    ? solid("route")
    : isPolygon
    ? solid("draw-polygon")
    : solid("location-dot");

  const placeName = props.name || (props.place && props.place.Name) || placeType;

  const Item = ({ label, onClick, icon: itemIcon, info, danger, highlight, index }) => (
    <div
      className={`pm-item${danger ? " danger" : ""}${highlight ? " highlight" : ""}`}
      style={{ "--i": index }}
      onClick={onClick}
    >
      <div className="pm-item-icon">
        <FontAwesomeIcon icon={itemIcon} />
      </div>
      <span className="pm-item-label">{label}</span>
      {info && (
        <button
          className="pm-item-info"
          onClick={(e) => { e.stopPropagation(); myAlert(info, "Info"); }}
          aria-label={`Info: ${label}`}
        >
          <FontAwesomeIcon icon={solid("info")} />
        </button>
      )}
    </div>
  );

  // Every other menu's Advanced-Mode gating uses a buildMenuList(advancedMode)
  // array + diff-count pattern that gets this hint for free (see
  // PlacesHeader.js/Schedule.js's appendAdvancedModeHint idiom) — this menu
  // is built from ad-hoc inline JSX conditionals instead, so it never got
  // one when the 8 items below were gated. Enumerated by hand here rather
  // than restructuring the whole render into a data-driven list. Found
  // 2026-10-05.
  const hiddenAdvancedCount = advancedMode ? 0 : (
    (isIcon ? 1 : 0) + // Set as Current Location
    (isPolygon ? 1 : 0) + // Filter Places Inside Area
    (GuideEditMode ? (
      1 + // Auto Update Photo
      1 + // Clear Photo
      (typeof props.action !== "undefined" ? 1 : 0) + // Edit Position on Map
      (isPolyLine && props.place.DirectionsRoute ? 1 : 0) + // Edit Directions
      (isPolyLine ? 1 : 0) + // Reverse Path Direction
      1 // Delete
    ) : 0)
  );

  if (AlertModalShow)
    return (
      <AlertModal
        show={AlertModalShow}
        onHide={() => setAlertModalShow(false)}
        attributes={{
          onHide: () => setAlertModalShow(false),
          AlertModalTitle: AlertModalTitle,
          AlertModalMessage: AlertModalMessage,
          AlertModalButtons: AlertModalButtons,
        }}
      />
    );
  else if (HTMLReaderModal)
    return (
      <HTMLReader
        html={HTMLContent}
        show={HTMLReaderModal}
        compact={HTMLReaderCompact}
        title={HTMLReaderTitle}
        onHide={() => closeHTMLReader()}
        // Already inside this place's own menu dialog — "Place Menu" just
        // returns to the normal menu list (unlike closeHTMLReader, which
        // also calls props.onHide() and closes the whole dialog). Scoped to
        // Place Details specifically — placemenulink: isn't exclusive to it,
        // a user can hand-insert it into other HTML content too (though
        // Video/Audio here are auto-generated player markup, not user HTML,
        // so this is mostly a defensive match with PlaceCard.js/Map.js's
        // identical scoping). Found 2026-10-06.
        onPlaceMenuLink={() => { if (HTMLReaderTitle === "Place Details") setHTMLReaderModal(false); }}
        showPaging={HTMLReaderPlaceId != null && props.placesList != null && props.placesList.length > 1}
        canGoPrevious={HTMLReaderPlaceId != null && props.placesList != null && props.placesList.indexOf(HTMLReaderPlaceId) > 0}
        canGoNext={
          HTMLReaderPlaceId != null &&
          props.placesList != null &&
          props.placesList.indexOf(HTMLReaderPlaceId) !== -1 &&
          props.placesList.indexOf(HTMLReaderPlaceId) < props.placesList.length - 1
        }
        onPrevious={() => goToPlace(-1)}
        onNext={() => goToPlace(1)}
      />
    );

  let idx = 0;

  return (
    <div className="modal">
      <Modal
        {...props}
        animation={false}
        dialogClassName="myModalClass pm-dialog"
        aria-labelledby="pm-title"
        centered
        scrollable={false}
        onHide={props.onHide}
      >
        <Modal.Body style={{ padding: 0 }}>
          <div className="pm-shell">
            <div className="pm-header">
              <div className={`pm-header-icon ${headerIconClass}`}>
                <FontAwesomeIcon icon={headerIcon} />
              </div>
              <div className="pm-header-text">
                <h2 className="pm-title" id="pm-title">{placeName}</h2>
                <span className="pm-subtitle">{placeType}</span>
              </div>
              <button className="pm-close" onClick={props.onHide} aria-label="Close">
                <FontAwesomeIcon icon={solid("xmark")} />
              </button>
            </div>

            <div className="pm-list">
              {_isSearchResult() ? (
                <>
                  <Item index={idx++} label="Add to Guide"               onClick={addResultToguide}         icon={solid("plus")}          info="Add this search result to the guide." />
                  {/* {props.place.photo_m !== "" && (
                    <Item index={idx++} label="Copy Photo to Place"       onClick={copyPhotoToPlace}          icon={solid("copy")}          info="Copy the photo from this place to another place." />
                  )} */}
                  <Item index={idx++} label="Remove from Search Results"  onClick={removeFromSearchResults}   icon={solid("xmark")}         />
                  <div className="pm-separator" />
                  <Item index={idx++} label="Show Place Details"             onClick={handleShowPlaceAttributes} icon={solid("list")}          info="Show the attributes of this place, e.g. name, category, etc." />
                  {isIcon && <Item index={idx++} label="View in Google Maps"          onClick={handleShowSearchResultInGoogleMaps} icon={solid("map")} info="Open this place in Google Maps." />}
                  {props.place.Hlink !== "" && (
                    <Item index={idx++} label="Open URL"                  onClick={handleShowPlaceUrl}        icon={solid("arrow-up-right-from-square")} info="Open the URL associated with this place." />
                  )}
                </>
              ) : (
                <>
                  {/* Navigation */}
                  <span className="pm-section-label">Navigate</span>
                  <Item index={idx++} label="Center in Map"               onClick={handleCenterInMap}         icon={solid("crosshairs")}    info="Center the map on this place." />

                  {/* Directions */}
                  {isIcon && (
                    <>
                      <div className="pm-separator" />
                      <span className="pm-section-label">Directions</span>
                      <Item index={idx++} label="Directions from here"    onClick={fromDirectionsPlace}       icon={solid("circle-dot")}    info="Set this place as the starting point for directions." />
                      <Item index={idx++} label="Add as waypoint"         onClick={addWayPointPlace}          icon={solid("ellipsis-vertical")} info="Add this place as a waypoint along the way." />
                      <Item index={idx++} label="Directions to here"      onClick={toDirectionsPlace}         icon={solid("location-dot")}  info="Set this place as the destination for directions." />
                    </>
                  )}
                  {isIcon && <Item index={idx++} label="Show in Google Maps"     onClick={handleShowInGoogleMaps}   icon={solid("map")}           info="Open this place in Google Maps." />}
                  
                  {/* Info */}
                  <div className="pm-separator" />
                  <span className="pm-section-label">Info</span>
                  <Item index={idx++} label="Show Place Details"              onClick={handleShowPlaceAttributes} icon={solid("list")}         info="Show the attributes of this place, e.g. name, category, etc." />
                  {/* {props.place.Info !== "" && (
                    <Item index={idx++} label="Show Place Notes"           onClick={handleShowPlaceInfo}      icon={solid("circle-info")}   info="Show the information content associated with this place." />
                  )} */}
                  {props.place.Hlink !== "" && (
                    <Item index={idx++} label="Open URL"                   onClick={handleShowPlaceUrl}       icon={solid("arrow-up-right-from-square")} info="Open the URL associated with this place." />
                  )}
                  {props.place.Link && props.place.Link.type !== "none" && (
                    <Item index={idx++} label="Show Place Link"            onClick={handleShowPathLink}       icon={solid("link")}          info="Show the place link, e.g. video, audio, path link, etc." />
                  )}
                  {/* {props.place.photo_m !== "" && (
                    <Item index={idx++} label="Copy Photo to Place"        onClick={copyPhotoToPlace}         icon={solid("copy")}          info="Copy the photo from this place to another place." />
                  )} */}
                  {isIcon && advancedMode && (
                    <Item index={idx++} label="Set as Current Location"    onClick={handleSetAsCurrentLocation} icon={solid("location-crosshairs")} info="Set this as your current location. Affects distance calculations." />
                  )}
                  {isPolygon && advancedMode && (
                    <Item index={idx++} label="Filter Places Inside Area"  onClick={filterPlacesByArea}       icon={solid("filter")}        info="Filter guide places to show only those inside this area." />
                  )}

                  {/* Discover */}
                  <div className="pm-separator" />
                  <span className="pm-section-label">Discover</span>
                  {/* <Item index={idx++} label="Ask a travel question"        onClick={() => setAiDialogShow(true)} icon={solid("robot")}      info="Use AI to answer travel questions about this place." /> */}
                  {isIcon && <Item index={idx++} label="Show Street View"        onClick={handleShowStreetView}     icon={solid("street-view")}   info="Show the street view of this place." />}
                  <Item index={idx++} label="Weather Forecast"             onClick={handleWeatherForecast}    icon={solid("cloud-sun")}     info="Open a weather forecast web app for this location." />
                  {isIcon && <Item index={idx++} label="Images from Web"   onClick={showWebImages}            icon={solid("images")}        info="Search Google Images for this place." />}
                  {isIcon && <Item index={idx++} label="Videos from Web"   onClick={showWebVideos}            icon={solid("film")}          info="Search YouTube for videos about this place." />}
                  {isIcon && <Item index={idx++} label="Articles from Web" onClick={showWebArticles}          icon={solid("newspaper")}     info="Search Google for articles about this place." />}

                  {/* Edit */}
                  {GuideEditMode && (
                    <>
                      <div className="pm-separator" />
                      <span className="pm-section-label">Edit</span>
                  <Item index={idx++} label={`Add to Schedule`}        onClick={handleAddEventA}          icon={solid("calendar-plus")} info="Create a scheduled event to visit this place." />
                      <Item index={idx++} label="Edit Place"               onClick={handleEditPlace}          icon={solid("pen")}           info={`Edit the ${placeType} attributes, e.g. name, category, etc.`} />
                      {advancedMode && (
                        <Item index={idx++} label={AutoSetPhotoLoading ? "Searching for photo..." : "Auto Update Photo"} onClick={autoSetPhoto} icon={solid("camera")} info="Automatically find a photo of this place and set it, using only images with no usage conditions (public domain / CC0) so nothing needs a credit." />
                      )}
                      {advancedMode && (
                        <Item index={idx++} label="Clear Photo" onClick={clearPhoto} icon={solid("eraser")} info="Remove this place's photo and show the default image instead. Use it when the photo is clearly wrong." />
                      )}
                      {/* <Item index={idx++} label="Combine Places Info"      onClick={combinePlaces}            icon={solid("layer-group")}   info={`Combine info from multiple places into this ${placeType}.`} /> */}
                      {typeof props.action !== "undefined" && advancedMode && (
                        <Item index={idx++} label="Edit Position on Map"   onClick={handleModifyLocation}     icon={solid("arrows-up-down-left-right")} info="Drag this marker to a new position on the map." />
                      )}
                      {isPolyLine && props.place.DirectionsRoute && advancedMode && (
                        <Item index={idx++} label="Edit Directions" onClick={handleEditDirections} icon={solid("route")} info="Reopen this path's original From/Waypoints/To places to change the stops or their order, then redraw it." />
                      )}
                      {isPolyLine && advancedMode && (
                        <Item index={idx++} label="Reverse Path Direction" onClick={handleReverseDirection}   icon={solid("right-left")}    info="Reverse the direction of this path." />
                      )}
                      {advancedMode && (
                        <>
                          <div className="pm-separator" />
                          <Item index={idx++} label={`Delete ${placeType}`}    onClick={handleDeletePlace}        icon={solid("trash")}         danger={true} />
                        </>
                      )}
                    </>
                  )}
                  {hiddenAdvancedCount > 0 && (
                    <Item
                      index={idx++}
                      label={`${hiddenAdvancedCount} more option${hiddenAdvancedCount === 1 ? "" : "s"} in Advanced Mode`}
                      onClick={() => window.dispatchEvent(new CustomEvent("toggleAdvancedMode"))}
                      icon={solid("wand-magic-sparkles")}
                      highlight={true}
                      info="Turn on Advanced Mode in Settings to see these options."
                    />
                  )}
                </>
              )}
            </div>
          </div>
        </Modal.Body>
      </Modal>
      {DirectionsDialogShow && (
        <DirectionsDialog
          show={DirectionsDialogShow}
          id={props.i}
          onHide={() => setDirectionsDialogShow(false)}
          onHidePrevious={props.onHide}
        />
      )}
      {AiDialogShow && (
        <AiDialog
          show={AiDialogShow}
          onHide={() => setAiDialogShow(false)}
          questions={AppSettings.questions2}
          id={props.i}
          user_info={user_info}
        />
      )}
      {ShowMultiselect && (
        <MultiSelectModal
          show={ShowMultiselect}
          onHide={() => setShowMultiselect(false)}
          MultiselectItems={MultiselectItems}
          MultiselectSelectedItems={MultiselectSelectedItems}
          MultiselectMode={MultiselectMode}
          MultiselectCallback={selectPlacesCallBack}
          MultiselectTitle={MultiselectTitle}
          MultiselectSearchText={MultiselectSearchText}
        />
      )}
    </div>
  );
};

export default PlaceModal;
